<template>
  <div class="table">
    <div class="crumbs">
      <div class="crumbs-content">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 企微会话查询 </el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 下拉菜单 -->
        <el-select v-model="selectedOption" size="small" style="margin-left: 20px; width: 120px" @change="handleDropdownChange">
          <el-option v-for="item in dropdownOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
    </div>

    <div class="container">
      <div class="app-container">
        <!-- 筛选条件区域 -->
        <div class="filter-container" style="margin-bottom: 20px; background: #f5f7fa; padding: 15px; border-radius: 4px">
          <div class="filter-row" style="margin-bottom: 15px">
            <!-- 公共条件：会话时间 (所有视图都有) -->
            <label style="margin-right: 10px">会话时间:</label>
            <el-date-picker
              v-model="listQuery.date_range"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="datePickerOptions"
              style="width: 240px; margin-right: 20px"
            >
            </el-date-picker>

            <!-- 客户昵称/备注 (客户列表和会话列表都有) -->
            <template v-if="viewType === 'customer' || viewType === 'session'">
              <label style="margin-right: 10px">客户昵称/备注:</label>
              <el-input maxlength="20" show-word-limit clearable v-model="listQuery.name" placeholder="请输入昵称/备注" style="width: 200px; margin-right: 20px" @keyup.enter.native="handleFilter"> </el-input>
            </template>

            <!-- 员工选择 (员工列表和客户列表都有，聊天搜索也要有) -->
            <template >
              <label style="margin-right: 10px">员工:</label>
              <el-cascader
                v-model="listQuery.userid_list"
                :options="employeeOptions"
                :props="cascaderProps"
                placeholder="请选择员工"
                style="width: 250px; margin-right: 20px"
                clearable
                filterable
                collapse-tags
              ></el-cascader>
            </template>

            <!-- 会话内容 (只有会话列表有) -->
            <template v-if="viewType === 'session'">
              <label style="margin-right: 10px">会话内容:</label>
              <el-input v-model="listQuery.content" placeholder="请输入关键词搜索" maxlength="200" show-word-limit clearable style="width: 250px; margin-right: 20px" @keyup.enter.native="handleFilter"> </el-input>
            </template>

            <!-- 有效会话 (只有客户列表有) -->
            <template v-if="viewType === 'customer'">
              <label style="margin-right: 10px">有效会话:</label>
              <el-tooltip
                placement="top"
              >
                <div slot="content">
                  <div style="margin-bottom: 5px" v-for="(it, idx) in effectiveSessionTip" :key="idx">
                    {{ it }}
                  </div>
                </div>
                <i class="el-icon-info" style="color: #909399;margin-right: 5px;"></i>
              </el-tooltip>
              <el-select v-model="listQuery.effective_type" size="small" style="width: 180px">
                <el-option v-for="item in effectiveSessionOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </template>

            <!-- 员工列表和会话列表的按钮 -->
            <template v-if="viewType === 'employee' || viewType === 'session'">
              <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"> 搜索 </el-button>
              <el-button class="filter-item" style="background-color: #f56c6c; color: white" @click="handleReset"> 重置 </el-button>
            </template>
          </div>

          <!-- 客户列表的第二行筛选条件 -->
          <div v-if="viewType === 'customer'" class="filter-row" style="margin-bottom: 15px">
            <!-- 客户标签 -->
            <label style="margin-right: 10px">客户标签:</label>
            <el-input maxlength="20" show-word-limit clearable v-model="listQuery.tag" placeholder="请输入客户标签" size="small" style="width: 200px; margin-right: 20px" @keyup.enter.native="handleFilter"> </el-input>

            <!-- 客户状态 -->
            <label style="margin-right: 10px">客户状态:</label>
            <el-tooltip
              v-if="!isSameDayRange"
              content="客户状态筛选仅在开始日期和结束日期为同一天时可用"
              placement="top"
            >
              <i class="el-icon-info" style="color: #909399;margin-right: 5px;"></i>
            </el-tooltip>
            <el-select
              v-model="listQuery.status"
              placeholder="请选择"
              style="width: 120px; margin-right: 20px"
              :disabled="!isSameDayRange"
            >
              <el-option label="未质检" :value="0"></el-option>
              <el-option label="已质检" :value="1"></el-option>
              <el-option label="AI已质检" :value="2"></el-option>
            </el-select>

            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"> 搜索 </el-button>
            <el-button class="filter-item" style="background-color: #f56c6c; color: white" @click="handleReset"> 重置 </el-button>
          </div>
        </div>

        <!-- 数据视图切换 -->
        <div style="margin-bottom: 20px">
          <el-radio-group v-model="viewType" @change="handleViewChange">
            <el-radio label="employee">员工列表</el-radio>
            <el-radio label="customer">客户列表</el-radio>
            <el-radio label="session">聊天搜索</el-radio>
          </el-radio-group>

          <div style="float: right">
            <el-button @click="handleRefresh" circle>
              <i class="el-icon-refresh"></i>
            </el-button>
          </div>
        </div>

        <!-- 员工列表视图 -->
        <div v-if="viewType === 'employee'">
          <el-table border v-loading="listLoading" :data="employeeTableData" style="width: 100%" max-height="600">
            <el-table-column prop="name" label="员工" />
            <el-table-column prop="department" label="部门">
              <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top" :disabled="!isDepartmentOverflow(scope.row.department)">
                  <div slot="content">{{ formatDepartmentTooltip(scope.row.department) }}</div>
                  <div class="department-cell">{{ formatDepartmentDisplay(scope.row.department) }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="last_msgtime" label="最近聊天时间" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link type="primary" @click="viewEmployeeDetail(scope.row)">聊天内容</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 客户列表视图 -->
        <div v-if="viewType === 'customer'">
          <el-table border v-loading="listLoading" :data="customerTableData" style="width: 100%" max-height="600">
            <el-table-column prop="external_name" label="微信昵称" />
            <el-table-column prop="remark" label="微信备注">
              <template slot-scope="scope">
                {{ formatRemarkDisplay(scope.row.remark) }}
              </template>
            </el-table-column>
            <el-table-column prop="contact_name" label="跟进员工" />
            <el-table-column prop="last_msgtime" label="最近聊天时间" />
            <!-- 状态列：仅在会话时间范围为1天内时显示 -->
            <el-table-column v-if="isSameDayRange" prop="status" label="状态">
              <template slot-scope="scope">
                <el-tag :type="qualityStatusTag(scope.row.quality_status).type">
                  {{ qualityStatusTag(scope.row.quality_status).text }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" :width="isSameDayRange ? '200' : '120'">
              <template slot-scope="scope">
                <el-link type="primary" @click="viewCustomerDetail(scope.row)">聊天内容</el-link>
                <!-- 完成质检按钮：仅在会话时间范围为1天内且未质检(0)时显示；已质检(1)、AI已质检(2)均无需完成质检 -->
                <el-link type="success" @click="contactCustomer(scope.row)" style="margin-left: 10px" v-if="isSameDayRange && scope.row.quality_status == 0">完成质检</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 会话列表视图 -->
        <div v-if="viewType === 'session'">
          <el-table border v-loading="listLoading" :data="sessionTableData" style="width: 100%" max-height="600">
            <el-table-column prop="send_name" label="发送人" />
            <el-table-column prop="receive_name" label="接收人" />
            <el-table-column prop="department" label="员工部门" />
            <el-table-column prop="msgtime" label="发送时间" />
            <el-table-column prop="content" label="聊天内容">
              <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top" :disabled="!isContentOverflow(scope.row.content)">
                  <div slot="content" v-html="highlightKeyword(scope.row.content)" class="tooltip-content"></div>
                  <div class="content-cell" v-html="highlightKeyword(scope.row.content)"></div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link type="primary" @click="viewCustomerDetail(scope.row)">查看完整聊天</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="handleList" />
      </div>
    </div>

    <!-- 聊天内容抽屉 -->
    <el-drawer :visible.sync="chatDrawerVisible" :with-header="false" size="80%" direction="rtl" class="chat-drawer" @close="handleDrawerClose">
      <div class="drawer-content">
        <!-- 抽屉头部 -->
        <div class="drawer-header">
          <h3>{{ currentEmployeeName || '聊天内容' }}</h3>
          <el-button type="text" icon="el-icon-close" @click="chatDrawerVisible = false" class="close-btn"> </el-button>
        </div>

        <!-- 搜索功能区域 -->
        <div class="search-section">
          <div class="search-form">
            <div class="search-row">
              <label><span class="required-star">*</span>会话时间:</label>
              <el-date-picker
                v-model="chatSearchQuery.dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="datePickerOptions"
                size="small"
                style="width: 250px; margin-right: 20px"
              >
              </el-date-picker>

              <label>会话内容:</label>
              <el-input v-model="chatSearchQuery.content" placeholder="请输入关键词搜索" maxlength="200" show-word-limit clearable size="small" style="width: 250px; margin-right: 20px" @keyup.enter.native="handleChatSearch"> </el-input>

              <!-- 客户昵称/备注搜索条件只在员工模式下显示 -->
              <template v-if="drawerMode === 'employee'">
                <label>客户昵称/备注:</label>
                <el-input maxlength="20" show-word-limit clearable v-model="chatSearchQuery.name" placeholder="请输入昵称/备注" size="small" style="width: 200px; margin-right: 20px" @keyup.enter.native="handleChatSearch"> </el-input>
              </template>

              <!-- 有效会话筛选 -- 只有员工列表的聊天内容展示 -->
              <template v-if="drawerMode === 'employee'">
                <label>有效会话:</label>
                <el-tooltip
                  placement="top"
                >
                  <div slot="content">
                    <div style="margin-bottom: 5px" v-for="(it, idx) in effectiveSessionTip" :key="idx">
                      {{ it }}
                    </div>
                  </div>
                  <i class="el-icon-info" style="color: #909399;margin-right: 5px;"></i>
                </el-tooltip>
                <el-select v-model="chatSearchQuery.effective_type" size="small" style="width: 180px">
                  <el-option v-for="item in effectiveSessionOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </template>

              <el-button type="primary" size="small" :loading="chatSearchLoading" :disabled="chatSearchLoading" @click="handleChatSearch">搜索</el-button>
              <el-button size="small" :disabled="chatSearchLoading" @click="handleChatReset" style="background-color: #f56c6c; color: white">重置</el-button>
            </div>
          </div>
        </div>

        <!-- 抽屉主体 -->
        <div class="drawer-body">
          <!-- 左侧：客户列表 (只在员工模式下显示) -->
          <div v-if="drawerMode === 'employee'" class="customer-list">
            <div class="list-header">
              <h4>备注/昵称</h4>
              <span class="count">({{ chatCustomerList.length }})</span>
            </div>
            <div class="customer-items">
              <div
                v-for="customer in chatCustomerList"
                :key="customer.external_userid"
                :class="['customer-item', { active: selectedCustomerId === customer.external_userid }]"
                @click="selectCustomer(customer)"
              >
                <div class="customer-info">
                  <div class="customer-name">{{ customer.remark ? `${customer.remark} / ${customer.name}` : customer.name }}</div>
                  <div v-if="customer.lastMessage" class="last-message">{{ customer.lastMessage }}</div>
                </div>
                <div class="customer-meta">
                  <div v-if="customer.last_msgtime" class="last-time">{{ customer.last_msgtime }}</div>
                  <div v-if="customer.unreadCount > 0" class="unread-count">{{ customer.unreadCount }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧：聊天详情 -->
          <div :class="['chat-detail', { 'full-width': drawerMode !== 'employee' }]">
            <!-- 客户信息卡片 -->
            <div v-if="selectedCustomer" class="customer-info-card">
              <div class="info-section">
                <h4>客户信息</h4>
                <div class="info-row">
                  <span class="label">客户昵称:</span>
                  <span class="value">{{ selectedCustomer.name }}</span>
                </div>
                <div class="info-row" v-if="selectedCustomer.remark">
                  <span class="label">备注:</span>
                  <span class="value">{{ selectedCustomer.remark }}</span>
                </div>
                <div v-if="selectedCustomer.player_snapshot && selectedCustomer.player_snapshot.status === 'FAILED'" class="info-row">
                  <span class="label">玩家资料:</span><span class="value">玩家资料获取失败，请稍后重试</span>
                </div>
                <template v-else-if="selectedCustomer.player_snapshot">
                  <div class="info-row"><span class="label">用户名:</span><span class="value">{{ selectedCustomer.player_snapshot.user_name || '—' }}</span></div>
                  <div class="info-row"><span class="label">子游戏名称:</span><span class="value">{{ selectedCustomer.player_snapshot.sub_game_name || '—' }}</span></div>
                  <div class="info-row"><span class="label">账号总充值:</span><span class="value">{{ formatPlayerCurrency(selectedCustomer.player_snapshot.account_total_recharge) }}</span></div>
                  <div class="info-row"><span class="label">角色 ID:</span><span class="value">{{ selectedCustomer.player_snapshot.role_id || '—' }}</span></div>
                  <div class="info-row"><span class="label">角色名:</span><span class="value">{{ selectedCustomer.player_snapshot.role_name || '—' }}</span></div>
                  <div class="info-row"><span class="label">区服 ID:</span><span class="value">{{ selectedCustomer.player_snapshot.server_id || '—' }}</span></div>
                  <div class="info-row"><span class="label">角色充值:</span><span class="value">{{ formatPlayerCurrency(selectedCustomer.player_snapshot.role_recharge) }}</span></div>
                </template>
                <div class="info-row">
                  <span class="label">企微标签:</span>
                  <div class="tags-container">
                    <el-tag v-for="tag in selectedCustomer.tags" :key="tag" size="mini" type="primary" class="tag-item">
                      {{ tag }}
                    </el-tag>
                  </div>
                </div>
                <div class="info-row">
                  <span class="label">个人标签:</span>
                  <div class="tags-container">
                    <el-tag v-for="tag in selectedCustomer.personalInfo" :key="tag" size="mini" type="primary" class="tag-item">
                      {{ tag }}
                    </el-tag>
                  </div>
                </div>
              </div>

              <div class="info-section">
                <h4>跟进信息</h4>
                <div class="info-row">
                  <span class="label">最近跟进时间:</span>
                  <span class="value">{{ selectedCustomer.follow_time }}</span>
                </div>
                <div class="info-row">
                  <span class="label">最近跟进员工:</span>
                  <span class="value">{{ selectedCustomer.assignedEmployee }}</span>
                </div>
                <div class="info-row">
                  <span class="label">归属客服:</span>
                  <span class="value">
                    <el-tag v-for="contact in selectedCustomer.belong_contact" :key="contact" size="mini" type="primary">
                      {{ contact }}
                    </el-tag>
                  </span>
                </div>
              </div>
            </div>

            <!-- 聊天消息区域 -->
            <div class="chat-messages" ref="chatMessages">
              <div class="messages-header">
                <div class="header-left">
                  <span>聊天记录</span>
                  <span class="message-count">共 {{ currentChatMessages.length }} 条消息</span>

                  <!-- 搜索导航按钮 -->
                  <div v-if="searchMatches.length > 1" class="search-navigation">
                    <span class="match-info">匹配到 {{ searchMatches.length }} 条消息</span>
                    <span class="match-info">{{ currentMatchIndex + 1 }}/{{ searchMatches.length }}</span>
                    <el-button size="mini" icon="el-icon-arrow-up" @click="goToPreviousMatch" title="上一个匹配"></el-button>
                    <el-button size="mini" icon="el-icon-arrow-down" @click="goToNextMatch" title="下一个匹配"></el-button>
                  </div>
                </div>
              </div>

              <div class="messages-list">
                <div v-for="message in currentChatMessages" :key="message.id" :class="['message-item', message.sender === 'customer' ? 'customer-message' : 'employee-message']">
                  <div class="message-avatar">
                    <img :src="message.avatar" :alt="message.senderName" />
                  </div>

                  <div class="message-content">
                    <div class="message-header">
                      <span class="sender-name">{{ message.senderName }}</span>
                      <span class="message-time">{{ message.time }}</span>
                    </div>

                    <div class="message-body">
                      <!-- 文本消息 -->
                      <div v-if="message.type === 'text'" class="text-message">
                        {{ message.content }}
                      </div>

                      <!-- 图片/表情消息 -->
                      <div v-else-if="message.type === 'image'" class="image-message">
                        <el-image
                          v-for="image in message.images"
                          :key="image"
                          :src="image"
                          :preview-src-list="getImagePreviewList()"
                          fit="cover"
                          style="max-width: 200px; max-height: 200px; border-radius: 8px; cursor: pointer;"
                        >
                          <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                            <span>{{ message.typeLabel }}加载失败</span>
                          </div>
                        </el-image>
                        <div v-if="!message.images.length" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                          <span>{{ message.typeLabel }}处理中</span>
                        </div>
                      </div>

                      <!-- 混合消息 -->
                      <div v-else-if="message.type === 'mixed'" class="mixed-message">
                        <div class="message-type-tag">{{ message.typeLabel }}</div>
                        <div v-if="message.content" class="text-message mixed-text">{{ message.content }}</div>
                        <div v-if="message.images.length" class="mixed-images">
                          <el-image
                            v-for="image in message.images"
                            :key="image"
                            :src="image"
                            :preview-src-list="getImagePreviewList()"
                            fit="cover"
                            style="max-width: 200px; max-height: 200px; border-radius: 8px; cursor: pointer;"
                          >
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                              <span>{{ message.typeLabel }}加载失败</span>
                            </div>
                          </el-image>
                        </div>
                      </div>

                      <!-- 其他消息类型 -->
                      <div v-else class="type-message">
                        <i class="el-icon-chat-dot-round"></i>
                        <div>
                          <div class="message-type-title">{{ message.typeLabel }}</div>
                          <div v-if="message.content" class="message-type-content">{{ message.content }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<style>
/* 全局样式确保 tooltip 中的关键词高亮生效 */
.el-tooltip__popper .highlight-keyword {
  color: #409eff !important;
  font-weight: 500 !important;
}

/* 修复级联选择器复选框样式 */
.el-cascader-panel .el-checkbox {
  margin-right: 8px;
}

.el-cascader-panel .el-checkbox__input {
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  display: inline-block;
  line-height: 1;
  position: relative;
  vertical-align: middle;
}

.el-cascader-panel .el-checkbox__inner {
  display: inline-block;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  background-color: #fff;
  z-index: 1;
  transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
}

.el-cascader-panel .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}

.el-cascader-panel .el-checkbox__input.is-checked .el-checkbox__inner::after {
  transform: rotate(45deg) scaleY(1);
}

.el-cascader-panel .el-checkbox__inner::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg) scaleY(0);
  width: 3px;
  transition: transform .15s ease-in .05s;
  transform-origin: center;
}
</style>

<script>
import {
  getQwCorpOptionApi,
  getQwContactOptionApi,
  getQwContactListApi,
  getQwChatLogExternalApi,
  getQwChatLogDetailApi,
  getQwExternalListApi,
  getQwChatLogListApi,
  completeQwChatLogCheckApi,
} from '@/api/wechatWork.js';
import Pagination from '@/components/pagination/index';
import { formatWecomMessage } from './messageFormatter';

export default {
  components: { Pagination },
  name: 'employeeList',
  data() {
    return {
      listLoading: false,
      total: 0,
      viewType: 'employee',
      selectedOption: '',
      // 下拉菜单选项 (企微企业列表)
      dropdownOptions: [],

      listQuery: {
        date_range: [],
        userid_list: [],
        name: '',
        status: '',
        tag: '',
        content: '',
        effective_type: 0, // 有效会话筛选项 默认全部会话
        page: 1,
        limit: 10,
      },

      employeeOptions: [],

      // 级联选择器配置
      cascaderProps: {
        multiple: true,
        checkStrictly: false, // 父子节点不互相关联
        value: 'value',
        label: 'label',
        children: 'children',
        emitPath: false // 只返回选中节点的值，不返回完整路径
      },

      employeeTableData: [],
      customerTableData: [],
      sessionTableData: [],

      // 聊天抽屉相关数据
      chatDrawerVisible: false,
      drawerMode: 'employee', // 抽屉模式: 'employee'(员工列表进入) | 'customer'(客户列表进入) | 'session'(会话列表进入)
      selectedCustomerId: null,
      selectedCustomer: null,
      currentEmployeeName: '', // 当前查看的客服名称
      currentEmployeeContactUserId: '', // 当前查看的员工contact_userid
      chatCustomerList: [],
      currentChatMessages: [],

      // 搜索匹配相关数据
      searchMatches: [], // 匹配的消息索引数组
      currentMatchIndex: -1, // 当前显示的匹配项索引
      searchKeyword: '', // 当前搜索关键词

      // 聊天搜索相关数据
      chatSearchQuery: {
        dateRange: [],
        content: '',
        name: '',
        effective_type: 0 // 有效会话筛选  默认 全部会话
      },
      chatSearchLoading: false, // 聊天搜索loading状态

      // 日期选择器配置 - 限制最大31天范围
      datePickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        // 限制选择范围不超过31天
        onPick: ({ minDate }) => {
          this.pickedDates = minDate ? [minDate] : [];
        },
        disabledDate: (time) => {
          if (this.pickedDates && this.pickedDates.length === 1) {
            const pickedDay = this.pickedDates[0];
            const maxDay = new Date(pickedDay.getTime() + 31 * 24 * 60 * 60 * 1000);
            const minDay = new Date(pickedDay.getTime() - 31 * 24 * 60 * 60 * 1000);
            return time.getTime() > maxDay.getTime() || time.getTime() < minDay.getTime();
          }
          return false;
        },
      },

      // 临时存储已选择的日期
      pickedDates: [],

      // 有效会话筛选
      effectiveSessionOptions: [
        { label: '全部会话', value: 0 },
        { label: '仅有效会话', value: 1 },
        { label: '客服无响应', value: 2 },
        { label: '客户无响应', value: 3 }
      ],
      effectiveSessionTip: [
        '仅有效会话：员工/客户双方均产生聊天记录的对话',
        '仅无效会话：员工/客户仅有一方有聊天记录的对话',
        '无效会话-员工无响应：仅客户产生聊天记录的对话',
        '无效会话-客户无响应：仅员工产生聊天记录的对话'
      ]
    };
  },
  computed: {
    // 判断日期范围是否为同一天
    isSameDayRange() {
      if (!this.listQuery.date_range || this.listQuery.date_range.length !== 2) {
        return false;
      }
      const [startDate, endDate] = this.listQuery.date_range;
      return startDate === endDate;
    }
  },
  watch: {
    // 监听日期范围变化，如果不是同一天则清空客户状态
    'listQuery.date_range': {
      handler(newVal, oldVal) {
        // 只有在日期范围真正改变时才处理
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          if (!this.isSameDayRange && this.listQuery.status !== '') {
            this.listQuery.status = '';
          }
        }
      },
      deep: true
    }
  },

  async mounted() {
    this.initDefaultDate();
    await this.loadCorpOptions();
    this.loadEmployeeOptions();
    this.handleList();
  },
  methods: {
    // 质检状态展示：0未质检 / 1已质检 / 2 AI已质检（AI质检后台状态联动）
    qualityStatusTag(status) {
      if (status == 1) return { type: 'success', text: '已质检' };
      if (status == 2) return { type: 'warning', text: 'AI已质检' };
      return { type: 'info', text: '未质检' };
    },
    // 高亮关键词
    highlightKeyword(content) {
      if (!content) return '';

      // 获取搜索关键词
      let keyword = '';
      if (this.viewType === 'session' && this.listQuery.content) {
        keyword = this.listQuery.content.trim();
      } else if (this.viewType === 'customer' && this.chatSearchQuery.content) {
        keyword = this.chatSearchQuery.content.trim();
      }

      if (!keyword) return content;

      // 转义特殊字符，防止正则表达式错误
      const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${escapedKeyword})`, 'gi');

      return content.replace(regex, '<span class="highlight-keyword">$1</span>');
    },

    // 判断内容是否超出显示区域
    isContentOverflow(content) {
      if (!content) return false;
      // 简单估算：如果内容长度超过30个字符，认为可能会超出
      return content.length > 30;
    },

    // 格式化部门显示（用于表格单元格）
    formatDepartmentDisplay(department) {
      if (!department) return '';

      // 如果是数组，用逗号连接
      if (Array.isArray(department)) {
        const departmentStr = department.join(', ');
        // 如果超过30个字符，截断并添加省略号
        return departmentStr.length > 30 ? departmentStr.substring(0, 30) + '...' : departmentStr;
      }

      // 如果是字符串，直接处理
      const departmentStr = String(department);
      return departmentStr.length > 30 ? departmentStr.substring(0, 30) + '...' : departmentStr;
    },

    // 格式化部门tooltip显示（完整内容）
    formatDepartmentTooltip(department) {
      if (!department) return '';

      // 如果是数组，用逗号连接
      if (Array.isArray(department)) {
        return department.join(', ');
      }

      // 如果是字符串，直接返回
      return String(department);
    },

    // 格式化备注显示
    formatRemarkDisplay(remark) {
      if (!remark) return '';

      // 如果是数组，用逗号连接
      if (Array.isArray(remark)) {
        return remark.join(', ');
      }

      // 如果是字符串，直接返回
      return String(remark);
    },

    // 判断部门内容是否需要显示tooltip
    isDepartmentOverflow(department) {
      if (!department) return false;

      // 如果是数组，检查连接后的长度
      if (Array.isArray(department)) {
        const departmentStr = department.join(', ');
        return departmentStr.length > 30;
      }

      // 如果是字符串，检查长度
      const departmentStr = String(department);
      return departmentStr.length > 30;
    },

    initDefaultDate() {
      // 设置默认时间为前一天
      const today = new Date();
      const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);

      const yesterdayStr = yesterday.toISOString().split('T')[0];

      this.listQuery.date_range = [yesterdayStr, yesterdayStr];
    },

    // 加载企微企业下拉框选项
    async loadCorpOptions() {
      try {
        const response = await getQwCorpOptionApi();
        if (response.code === 200 && response.data) {
          this.dropdownOptions = response.data.map((item) => ({
            value: item.corpid,
            label: item.name,
          }));

          // 默认选择第一个选项
          if (this.dropdownOptions.length > 0) {
            this.selectedOption = this.dropdownOptions[0].value;
          }
        }
      } catch (error) {
        console.error('加载企微企业选项失败:', error);
      }
    },

    // 加载员工下拉框选项
    async loadEmployeeOptions() {
      try {
        const params = {
          corpid: this.selectedOption,
        };
        const response = await getQwContactOptionApi(params);
        if (response.code === 200 && response.data) {
          // 将接口返回的数据转换为级联选择器的层级结构
          const employeeOptions = [];

          response.data.forEach((department) => {
            if (department.user && Array.isArray(department.user)) {
              const departmentNode = {
                value: department.department_id || department.department_name, // 部门ID作为值
                label: department.department_name, // 部门名称作为标签
                children: []
              };

              // 添加该部门下的员工
              department.user.forEach((user) => {
                departmentNode.children.push({
                  // 因为不同部门里边的客服userid会有重复的，选择的时候会把其他部门的都会选上，操作层面的影响
                  value: `${departmentNode.value}#$&${user.userid}`, // 员工ID作为值
                  label: user.name, // 员工姓名作为标签
                });
              });

              employeeOptions.push(departmentNode);
            }
          });

          this.employeeOptions = employeeOptions;
        }
      } catch (error) {
        console.error('加载员工选项失败:', error);
      }
    },

    handleDropdownChange(value) {
      console.log('企微企业选择变更:', value);
      // 重新加载员工选项
      this.loadEmployeeOptions();
      // 重新加载数据
      this.handleList();
    },

    // 因为不同部门里边的客服userid会有重复的，选择的时候会把其他部门的都会选上，操作层面的影响
    handleGetUseridList (data) {
      return [...new Set(data.map(it => it.split('#$&')[1]))]
    },

    handleList() {
      // 验证搜索条件
      if (!this.validateSearchConditions()) {
        return;
      }

      this.listLoading = true;

      const params = {
        ...this.listQuery,
        view_type: this.viewType,
        begin_date: this.listQuery.date_range[0],
        end_date: this.listQuery.date_range[1],
      };

      if (this.viewType === 'employee') {
        this.loadEmployeeData(params);
      } else if (this.viewType === 'customer') {
        this.loadCustomerData(params);
      } else if (this.viewType === 'session') {
        this.loadSessionData(params);
      }
    },

    async loadEmployeeData(params) {
      try {
        const requestData = {
          corpid: this.selectedOption,
          page: params.page || 1,
          limit: params.limit || 10,
          begin_date: params.begin_date,
          end_date: params.end_date,
          userid_list: this.handleGetUseridList(params.userid_list),
        };

        const response = await getQwContactListApi(requestData);
        if (response.code === 200 && response.data) {
          this.employeeTableData = response.data.data || [];
          this.total = response.data.total || 0;
        }
      } catch (error) {
        this.$message.error('加载员工数据失败');
      } finally {
        this.listLoading = false;
      }
    },

    async loadCustomerData(params) {
      try {
        const requestData = {
          corpid: this.selectedOption,
          page: params.page || 1,
          limit: params.limit || 10,
          begin_date: params.begin_date,
          end_date: params.end_date,
          name: params.name,
          status: params.status,
          tag: params.tag,
          userid_list: this.handleGetUseridList(params.userid_list),
          effective_type: params.effective_type,
        };

        const response = await getQwExternalListApi(requestData);
        if (response.code === 200 && response.data) {
          this.customerTableData = response.data.data || [];
          this.total = response.data.total || 0;
        }
      } catch (error) {
        console.error('加载客户数据失败:', error);
      } finally {
        this.listLoading = false;
      }
    },

    async loadSessionData(params) {
      try {
        const requestData = {
          corpid: this.selectedOption,
          page: params.page || 1,
          limit: params.limit || 10,
          begin_date: params.begin_date,
          end_date: params.end_date,
          content: params.content,
          name: params.name,
          userid_list: this.handleGetUseridList(params.userid_list)
        };

        const response = await getQwChatLogListApi(requestData);
        if (response.code === 200 && response.data) {
          this.sessionTableData = response.data.data || [];
          this.total = response.data.total || 0;
        }
      } catch (error) {
        console.error('加载会话数据失败:', error);
      } finally {
        this.listLoading = false;
      }
    },

    handleViewChange(value) {
      this.viewType = value;
      this.listQuery.page = 1;
      this.handleList();
    },

    handleFilter() {
      // 验证搜索条件
      if (!this.validateSearchConditions()) {
        return;
      }

      this.listQuery.page = 1;
      this.handleList();
    },

    handleReset() {
      this.listQuery = {
        date_range: [],
        userid_list: [],
        name: '',
        status: '',
        tag: '',
        content: '',
        page: 1,
        limit: 10,
      };
      this.initDefaultDate();
      this.handleList();
    },

    handleRefresh() {
      this.handleList();
    },

    async viewEmployeeDetail(row) {
      // 打开聊天抽屉，显示该员工相关的客户聊天记录
      this.chatDrawerVisible = true;
      this.drawerMode = 'employee'; // 设置抽屉模式为员工模式
      this.currentEmployeeName = row.employee_name; // 设置当前客服名称
      this.currentEmployeeContactUserId = row.contact_userid; // 设置当前员工contact_userid

      // 同步外部搜索条件到抽屉内搜索条件
      this.chatSearchQuery.dateRange = [...this.listQuery.date_range];
      // 从员工列表进入时，清空会话内容搜索条件
      this.chatSearchQuery.content = '';

      // 开始loading
      this.chatSearchLoading = true;

      try {
        // 获取客户列表
        const response = await getQwChatLogExternalApi({
          corpid: this.selectedOption,
          contact_userid: row.contact_userid,
          ...this.chatSearchQuery,
          begin_date: this.chatSearchQuery.dateRange && this.chatSearchQuery.dateRange[0],
          end_date: this.chatSearchQuery.dateRange && this.chatSearchQuery.dateRange[1],
        });

        if (response.code === 200 && response.data) {
          // 处理客户列表数据
          this.chatCustomerList = this.formatCustomerList(response.data);

          // 默认选择第一个客户
          if (this.chatCustomerList.length > 0) {
            this.selectCustomer(this.chatCustomerList[0]);
          }
        } else {
          this.$message.error('获取客户列表失败');
          this.chatCustomerList = [];
        }
      } catch (error) {
        console.error('获取客户列表失败:', error);
        this.$message.error('获取客户列表失败');
        this.chatCustomerList = [];
      } finally {
        // 结束loading
        this.chatSearchLoading = false;
      }
    },

    // 格式化客户列表数据
    formatCustomerList(customerData) {
      if (!Array.isArray(customerData)) {
        return [];
      }

      return customerData.map((item) => ({
        ...item,
        // 处理备注字段，如果是数组则合并为字符串
        remark: Array.isArray(item.remark) ? item.remark.join(', ') : item.remark || '',
        // 确保必要字段存在
        name: item.name || '未知客户',
        external_userid: item.external_userid || item.id,
        last_msgtime: item.last_msgtime || item.msgtime || '',
      }));
    },

    // 验证搜索条件
    validateSearchConditions() {
      // 1. 验证会话时间必选
      if (!this.listQuery.date_range || this.listQuery.date_range.length !== 2 || !this.listQuery.date_range[0] || !this.listQuery.date_range[1]) {
        this.$message.warning('请选择会话时间');
        return false;
      }

      // 2. 聊天搜索内容必选验证
      if (this.viewType === 'session') {
        if (!this.listQuery.content || this.listQuery.content.trim() === '') {
          this.$message.warning('请填写会话内容搜索条件');
          return false;
        }
      }

      // 3. 客户状态筛选条件验证（仅客户列表视图）
      if (this.viewType === 'customer' && this.listQuery.status !== '') {
        if (!this.isSameDayRange) {
          this.$message.warning('客户状态筛选仅在开始日期和结束日期为同一天时可用');
          return false;
        }
      }

      return true;
    },

    // 根据会话列表行数据查找目标客户
    findTargetCustomer(sessionRow, customerList) {
      if (!sessionRow || !Array.isArray(customerList) || customerList.length === 0) {
        return null;
      }

      // 通过客户ID匹配（会话列表中的客户标识字段）
      if (sessionRow.external_userid) {
        const customer = customerList.find((c) => c.external_userid === sessionRow.external_userid);
        if (customer) {
          return customer;
        }
      }

      return null; // 没有找到匹配的客户
    },

    async viewCustomerDetail(row) {
      // 打开聊天抽屉，直接显示指定客户的聊天记录
      this.chatDrawerVisible = true;
      this.drawerMode = this.viewType === 'session' ? 'session' : 'customer'; // 根据当前视图设置抽屉模式
      this.currentEmployeeName = row.contact_name; // 设置当前客服名称
      this.currentEmployeeContactUserId = row.contact_userid; // 设置当前员工contact_userid

      // 同步外部搜索条件到抽屉内搜索条件
      this.chatSearchQuery.dateRange = [...this.listQuery.date_range];

      // 如果是从会话列表进入，同步会话内容搜索条件
      if (this.viewType === 'session') {
        this.chatSearchQuery.content = this.listQuery.content || '';
      } else {
        // 其他情况清空会话内容搜索条件
        this.chatSearchQuery.content = '';
      }

      // 设置选中的客户信息
      this.selectedCustomerId = row.external_userid;
      this.selectedCustomer = {
        external_userid: row.external_userid,
        name: row.external_name || row.name || '未知客户',
        remark: row.remark || '',
        // 其他客户信息会在loadChatMessages中更新
      };

      // 开始loading
      this.chatSearchLoading = true;

      try {
        // 直接加载该客户的聊天记录，传递搜索查询参数
        await this.loadChatMessages(row.external_userid, this.chatSearchQuery);
      } catch (error) {
        console.error('加载客户聊天记录失败:', error);
        this.$message.error('加载聊天记录失败');
      } finally {
        // 结束loading
        this.chatSearchLoading = false;
      }
    },

    async contactCustomer(row) {
      try {
        // 二次确认弹框
        await this.$confirm(
          `确定要完成对客户"${row.external_name || row.name || '未知客户'}"的质检吗？`,
          '确认质检',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }
        );

        // 用户确认后执行质检完成操作
        await completeQwChatLogCheckApi({
          corpid: this.selectedOption,
          external_userid: row.external_userid,
          contact_userid: row.contact_userid,
          begin_date: this.listQuery.date_range && this.listQuery.date_range[0],
          end_date: this.listQuery.date_range && this.listQuery.date_range[1],
        });

        // 请求成功后，直接修改前端数据状态
        this.updateCustomerQualityStatus(row.external_userid, 1);

        this.$message.success('质检完成');
      } catch (error) {
        // 用户取消或操作失败
        if (error === 'cancel') {
          // 用户取消操作，不显示错误信息
          return;
        }
        console.error('质检完成失败:', error);
        this.$message.error('质检完成失败，请重试');
      }
    },

    // 更新客户质检状态（前端临时修改，避免重新请求列表）
    updateCustomerQualityStatus(externalUserId, qualityStatus) {
      // 更新客户列表中的数据
      if (this.customerTableData && this.customerTableData.length > 0) {
        const customerIndex = this.customerTableData.findIndex(
          customer => customer.external_userid === externalUserId
        );
        if (customerIndex !== -1) {
          // 使用 Vue.set 确保响应式更新
          this.$set(this.customerTableData[customerIndex], 'quality_status', qualityStatus);
        }
      }
    },

    // 聊天抽屉相关方法
    selectCustomer(customer) {
      this.selectedCustomerId = customer.external_userid;
      this.selectedCustomer = customer;
      this.loadChatMessages(customer.external_userid, this.chatSearchQuery);
    },

    async loadChatMessages(customerId, searchQuery = null) {
      try {
        // 如果没有传递搜索查询，使用当前的搜索查询参数
        const query = searchQuery || this.chatSearchQuery;

        // 总是清除之前的搜索匹配，稍后会重新执行匹配
        this.clearSearchMatches();

        const requestData = {
          corpid: this.selectedOption,
          external_userid: customerId,
          contact_userid: this.currentEmployeeContactUserId,
          begin_date: query.dateRange && query.dateRange[0],
          end_date: query.dateRange && query.dateRange[1],
          content: query.content,
          customer_name: query.name,
        };

        const response = await getQwChatLogDetailApi(requestData);
        if (response.code === 200 && response.data) {
          // 更新客户信息
          if (response.data.external) {
            this.updateSelectedCustomerInfo(response.data.external);
          }

          // 处理聊天记录
          const chatMessages = response.data.chat || [];
          this.currentChatMessages = this.formatChatMessages(chatMessages, response.data.external, response.data.contact);
        } else {
          console.error('加载聊天消息失败:', error);
        }
      } catch (error) {
        console.error('加载聊天消息失败:', error);
      }

      // 滚动到指定位置或底部
      this.$nextTick(() => {
        // 如果有搜索关键词，执行搜索匹配
        if (this.chatSearchQuery && this.chatSearchQuery.content && this.chatSearchQuery.content.trim()) {
          // 使用 setTimeout 确保DOM完全渲染后再执行搜索匹配
          setTimeout(() => {
            this.findAndNavigateToMatches();
          }, 100);
        } else {
          // 否则滚动到底部
          this.scrollToBottom();
        }
      });
    },

    // 更新选中客户的信息
    updateSelectedCustomerInfo(externalData) {
      if (this.selectedCustomer) {
        // 更新客户基本信息
        this.selectedCustomer.name = externalData.name || this.selectedCustomer.name;
        this.selectedCustomer.remark = Array.isArray(externalData.remark) ? externalData.remark.join(', ') : externalData.remark || this.selectedCustomer.remark;
        this.selectedCustomer.avatar = externalData.avatar || this.selectedCustomer.avatar;
        this.$set(this.selectedCustomer, 'player_snapshot', externalData.player_snapshot || null);

        // 更新企业标签
        if (externalData.corp_tag && Array.isArray(externalData.corp_tag)) {
          const corpTags = [];
          externalData.corp_tag.forEach((group) => {
            if (group.tag && Array.isArray(group.tag)) {
              corpTags.push(...group.tag);
            }
          });
          this.selectedCustomer.tags = corpTags;
        }
        this.selectedCustomer.personalInfo = externalData.user_tag || [];

        // 更新跟进信息
        this.selectedCustomer.assignedEmployee = externalData.follow_contact || this.selectedCustomer.assignedEmployee;
        this.selectedCustomer.follow_time = externalData.follow_time;
        this.selectedCustomer.belong_contact = externalData.belong_contact || [];
      }
    },

    formatPlayerCurrency(value) {
      if (value === null || value === undefined || value === '') return '—';
      const amount = Number(value);
      if (Number.isNaN(amount)) return '—';
      return '¥' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    // 格式化聊天消息
    formatChatMessages(chatMessages, externalData, contactData) {
      if (!Array.isArray(chatMessages)) {
        return [];
      }

      return chatMessages.map((msg, index) => {
        const isFromCustomer = msg.message_from === externalData.external_userid;
        const displayMessage = formatWecomMessage(msg);

        return {
          id: index + 1,
          sender: isFromCustomer ? 'customer' : 'employee',
          senderName: isFromCustomer ? externalData.name : contactData.name,
          content: displayMessage.content,
          time: this.formatTime(msg.msgtime),
          type: displayMessage.displayType,
          msgtype: msg.msgtype,
          typeLabel: displayMessage.typeLabel,
          images: displayMessage.images,
          avatar: isFromCustomer
            ? externalData.avatar || '//assets.hzwxbz2.cn/sy/work_sn/img/03b0d39583f48206768a7534e55bcpng.png'
            : contactData.avatar || '//assets.hzwxbz2.cn/sy/work_sn/img/f0ee8a3c7c9638a54940382568c9dpng.png',
          // 保留原始消息数据以备后用
          originalMessage: msg,
        };
      });
    },

    // 格式化时间
    formatTime(timeStr) {
      if (!timeStr) return '';

      try {
        const date = new Date(timeStr);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        console.error('时间格式化失败:', error);
        return timeStr;
      }
    },

    // 获取当前聊天中的所有图片列表，用于图片预览
    getImagePreviewList() {
      if (!this.currentChatMessages || this.currentChatMessages.length === 0) {
        return [];
      }

      return this.currentChatMessages
        .reduce((list, message) => list.concat(message.images || []), [])
        .filter(Boolean);
    },



    // 滚动到底部
    scrollToBottom() {
      if (this.$refs.chatMessages) {
        const messagesContainer = this.$refs.chatMessages.querySelector('.messages-list');
        if (messagesContainer) {
          messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }
      }
    },



    // 搜索匹配相关方法
    findAndNavigateToMatches() {
      // 清除之前的搜索结果
      this.clearSearchMatches();

      const keyword = this.chatSearchQuery.content;
      if (!keyword || !keyword.trim()) {
        return;
      }

      this.searchKeyword = keyword.trim();
      this.searchMatches = [];

      // 在聊天消息中查找匹配项
      this.currentChatMessages.forEach((message, index) => {
        if ((message.type === 'text' || message.type === 'mixed') && message.content) {
          const content = message.content.toLowerCase();
          const searchKey = this.searchKeyword.toLowerCase();

          if (content.includes(searchKey)) {
            this.searchMatches.push(index);
          }
        }
      });

      // 如果找到匹配项，定位到最近的一条匹配消息（最后一条）
      if (this.searchMatches.length > 0) {
        this.currentMatchIndex = this.searchMatches.length - 1; // 定位到最后一条匹配
        this.navigateToMatch(this.currentMatchIndex);
      }
    },

    clearSearchMatches() {
      this.searchMatches = [];
      this.currentMatchIndex = -1;
      this.searchKeyword = '';

      // 清除所有高亮效果
      this.$nextTick(() => {
        if (this.$refs.chatMessages) {
          const messageElements = this.$refs.chatMessages.querySelectorAll('.message-item');
          messageElements.forEach(element => {
            element.classList.remove('search-highlight');
          });
        }
      });
    },

    navigateToMatch(matchIndex) {
      if (matchIndex < 0 || matchIndex >= this.searchMatches.length) {
        return;
      }

      this.currentMatchIndex = matchIndex;
      const messageIndex = this.searchMatches[matchIndex];

      this.$nextTick(() => {
        if (this.$refs.chatMessages) {
          const messagesContainer = this.$refs.chatMessages.querySelector('.messages-list');
          const messageElements = messagesContainer.querySelectorAll('.message-item');

          if (messageElements[messageIndex]) {
            const targetElement = messageElements[messageIndex];

            // 清除之前的高亮
            messageElements.forEach(el => el.classList.remove('search-highlight'));

            // 高亮当前匹配项
            targetElement.classList.add('search-highlight');

            // 滚动到目标位置
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    },

    goToPreviousMatch() {
      if (this.searchMatches.length === 0) return;

      const newIndex = this.currentMatchIndex > 0 ? this.currentMatchIndex - 1 : this.searchMatches.length - 1;
      this.navigateToMatch(newIndex);
    },

    goToNextMatch() {
      if (this.searchMatches.length === 0) return;

      const newIndex = this.currentMatchIndex < this.searchMatches.length - 1 ? this.currentMatchIndex + 1 : 0;
      this.navigateToMatch(newIndex);
    },

    // 聊天搜索相关方法
    async handleChatSearch() {
      // 防止重复点击
      if (this.chatSearchLoading) {
        return;
      }

      // 验证会话时间必填
      if (!this.chatSearchQuery.dateRange || this.chatSearchQuery.dateRange.length !== 2 || !this.chatSearchQuery.dateRange[0] || !this.chatSearchQuery.dateRange[1]) {
        this.$message.warning('请选择会话时间');
        return;
      }

      if (!this.currentEmployeeContactUserId) {
        this.$message.warning('请先选择员工');
        return;
      }

      // 开始loading
      this.chatSearchLoading = true;

      try {
        if (this.drawerMode === 'employee') {
          // 员工模式：重新请求客户列表（带搜索条件）
          const response = await getQwChatLogExternalApi({
            corpid: this.selectedOption,
            contact_userid: this.currentEmployeeContactUserId,
            ...this.chatSearchQuery,
            begin_date: this.chatSearchQuery.dateRange && this.chatSearchQuery.dateRange[0],
            end_date: this.chatSearchQuery.dateRange && this.chatSearchQuery.dateRange[1],
          });

          if (response.code === 200 && response.data) {
            // 处理客户列表数据
            this.chatCustomerList = this.formatCustomerList(response.data);

            // 如果有客户列表，选择第一个客户并加载聊天记录
            if (this.chatCustomerList.length > 0) {
              const firstCustomer = this.chatCustomerList[0];
              this.selectedCustomerId = firstCustomer.external_userid;
              this.selectedCustomer = firstCustomer;

              // 加载该客户的聊天记录
              await this.loadChatMessages(firstCustomer.external_userid, this.chatSearchQuery);

              // 查找匹配的消息并定位
              this.findAndNavigateToMatches();
              this.$message.success('搜索完成');
            } else {
              // 没有找到符合条件的客户
              this.selectedCustomerId = null;
              this.selectedCustomer = null;
              this.currentChatMessages = [];
              this.$message.info('未找到符合条件的客户');
            }
          } else {
            this.$message.error('获取客户列表失败');
          }
        } else {
          // 客户/会话模式：直接搜索当前客户的聊天记录
          if (this.selectedCustomerId) {
            await this.loadChatMessages(this.selectedCustomerId, this.chatSearchQuery);

            // 查找匹配的消息并定位
            this.findAndNavigateToMatches();
            this.$message.success('搜索完成');
          } else {
            this.$message.warning('未选择客户');
          }
        }
      } catch (error) {
        console.error('搜索失败:', error);
        this.$message.error('搜索失败');
      } finally {
        // 结束loading
        this.chatSearchLoading = false;
      }
    },

    async handleChatReset() {
      // 防止重复点击
      if (this.chatSearchLoading) {
        return;
      }

      // 重置搜索条件，但保持会话时间为外部的时间范围
      this.chatSearchQuery = {
        dateRange: [...this.listQuery.date_range], // 保持外部的时间范围
        content: '',
        name: '',
      };

      // 清除搜索匹配
      this.clearSearchMatches();

      if (!this.currentEmployeeContactUserId) {
        this.$message.warning('请先选择员工');
        return;
      }

      // 开始loading
      this.chatSearchLoading = true;

      try {
        if (this.drawerMode === 'employee') {
          // 员工模式：重新请求客户列表（不带搜索条件）
          const response = await getQwChatLogExternalApi({
            corpid: this.selectedOption,
            contact_userid: this.currentEmployeeContactUserId,
            ...this.chatSearchQuery,
            begin_date: this.chatSearchQuery.dateRange && this.chatSearchQuery.dateRange[0],
            end_date: this.chatSearchQuery.dateRange && this.chatSearchQuery.dateRange[1],
          });

          if (response.code === 200 && response.data) {
            // 处理客户列表数据
            this.chatCustomerList = this.formatCustomerList(response.data);

            // 如果有客户列表，选择第一个客户并加载聊天记录
            if (this.chatCustomerList.length > 0) {
              const firstCustomer = this.chatCustomerList[0];
              this.selectedCustomerId = firstCustomer.external_userid;
              this.selectedCustomer = firstCustomer;

              // 加载该客户的聊天记录
              await this.loadChatMessages(firstCustomer.external_userid, this.chatSearchQuery);
            } else {
              this.selectedCustomerId = null;
              this.selectedCustomer = null;
              this.currentChatMessages = [];
            }
          }
        } else {
          // 客户/会话模式：直接重新加载当前客户的聊天记录
          if (this.selectedCustomerId) {
            await this.loadChatMessages(this.selectedCustomerId, this.chatSearchQuery);
          }
        }

        this.$message.info('搜索条件已重置');
      } catch (error) {
        console.error('重置失败:', error);
        this.$message.error('重置失败');
      } finally {
        // 结束loading
        this.chatSearchLoading = false;
      }
    },

    // 抽屉关闭时的处理
    handleDrawerClose() {
      // 重置搜索条件
      this.chatSearchQuery = {
        dateRange: [],
        content: '',
        name: '',
      };

      // 清除搜索匹配状态
      this.clearSearchMatches();

      // 重置loading状态
      this.chatSearchLoading = false;

      // 清除选中的客户和聊天记录
      this.selectedCustomerId = null;
      this.selectedCustomer = null;
      this.currentChatMessages = [];
      this.chatCustomerList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.crumbs-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.filter-container {
  font-size: 14px;
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.filter-row label {
  font-weight: 500;
  color: #606266;
}

.el-table {
  font-size: 14px;
}

.el-table .el-table__cell {
  padding: 8px 0;
}

/* 部门单元格样式 */
.department-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}

/* 聊天抽屉样式 */
.chat-drawer {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.drawer-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}

.drawer-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  font-size: 18px;
  color: #999;
}

.drawer-body {
  flex: 1;
  display: flex;
  height: calc(100vh - 80px);
  overflow: hidden;
}

/* 左侧客户列表 */
.customer-list {
  width: 300px;
  border-right: 1px solid #e8e8e8;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
}

.list-header {
  padding: 15px 20px;
  border-bottom: 1px solid #e8e8e8;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.count {
  font-size: 12px;
  color: #999;
}

.customer-items {
  flex: 1;
  overflow-y: auto;
}

.customer-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  transition: background-color 0.2s;
  background: #fff;
}

.customer-item:hover {
  background: #f0f0f0;
}

.customer-item.active {
  background: #e6f7ff;
  border-right: 3px solid #1890ff;
}

.customer-info {
  flex: 1;
  min-width: 0;
}

.customer-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.last-message {
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.customer-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.last-time {
  font-size: 11px;
  color: #999;
  margin-bottom: 4px;
}

.unread-count {
  background: #ff4d4f;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  min-width: 16px;
  text-align: center;
}

/* 右侧聊天详情 */
.chat-detail {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  height: 100%;
  overflow: hidden;
}

/* 客户信息卡片 */
.customer-info-card {
  padding: 20px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
  display: flex;
  gap: 40px;
}

.info-section h4 {
  margin: 0 0 15px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.info-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  font-size: 13px;
}

.info-row .label {
  color: #666;
  margin-right: 8px;
  min-width: 80px;
  flex-shrink: 0;
}

.info-row .value {
  color: #333;
  font-weight: 500;
}

/* 标签容器样式 */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 400px;
  flex: 1;
}

.tag-item {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  word-break: break-all;
  max-width: 100%;
}

.tags {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

/* 聊天消息区域 */
.chat-messages {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.messages-header {
  padding: 15px 20px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;

  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;

    span:first-child {
      font-size: 14px;
      font-weight: 600;
      color: #333;
    }
  }
}

.message-count {
  font-size: 12px;
  color: #999;
}

.messages-list {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.message-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;

  &.customer-message {
    flex-direction: row;

    .message-avatar {
      margin-right: 12px;
    }

    .message-header {
      justify-content: flex-start;
    }
  }

  &.employee-message {
    flex-direction: row-reverse;

    .message-avatar {
      margin-left: 12px;
    }

    .message-header {
      justify-content: flex-end;
    }

    .sender-name {
      margin-left: 8px;
      margin-right: 0;
    }
  }

  // 搜索高亮样式
  &.search-highlight {
    background-color: #fff3cd !important;
    border: 2px solid #ffc107 !important;
    border-radius: 4px !important;
    transition: all 0.3s ease !important;
  }
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.message-content {
  max-width: 60%;
  min-width: 100px;
}

.message-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  font-size: 12px;

  .sender-name {
    font-weight: 500;
    color: #333;
    margin-right: 8px;
  }

  .message-time {
    color: #999;
  }
}

.message-body {
  position: relative;

  /* 消息气泡样式 */
  .text-message {
    background: #f0f0f0;
    padding: 10px 15px;
    border-radius: 18px;
    font-size: 14px;
    line-height: 1.4;
    color: #333;
    word-wrap: break-word;
  }

  .image-message {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .image-slot {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 200px;
      height: 150px;
      background: #f5f7fa;
      border: 1px dashed #c0c4cc;
      border-radius: 8px;
      color: #909399;
      font-size: 14px;

      i {
        font-size: 24px;
        margin-bottom: 8px;
      }
    }
  }

  .mixed-message {
    .message-type-tag {
      display: inline-block;
      margin-bottom: 6px;
      padding: 2px 8px;
      border-radius: 10px;
      background: #eef5ff;
      color: #409eff;
      font-size: 12px;
    }

    .mixed-text {
      margin-bottom: 8px;
    }

    .mixed-images {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }

  .type-message {
    display: flex;
    align-items: center;
    background: #f0f0f0;
    padding: 10px 15px;
    border-radius: 18px;
    font-size: 14px;
    color: #333;
    gap: 8px;
    max-width: 360px;
  }

  .message-type-title {
    font-weight: 600;
  }

  .message-type-content {
    margin-top: 3px;
    color: #666;
    word-break: break-word;
  }
}

// 员工消息的特殊样式
.employee-message .message-body {
  .text-message {
    background: #1890ff;
    color: white;
  }

  .type-message {
    background: #1890ff;
    color: white;

    .message-type-content {
      color: rgba(255, 255, 255, 0.85);
    }
  }
}

/* 搜索功能区域样式 */
.search-section {
  border-bottom: 1px solid #e8e8e8;
  background: #f8f9fa;
}

/* 必填项星号样式 */
.required-star {
  color: #f56c6c;
  margin-right: 2px;
}

.search-form {
  padding: 15px 20px;
}

.search-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-row label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
  margin-right: 8px;
  white-space: nowrap;
}

.search-row .el-button {
  margin-left: 10px;
}

.content-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.highlight-keyword {
  color: #409eff;
  font-weight: 500;
}

.tooltip-content {
  max-width: 300px;
  word-wrap: break-word;
  white-space: normal;
}

/* 全宽度聊天详情样式 */
.chat-detail.full-width {
  width: 100% !important;
  flex: 1 !important;
}

/* 聊天记录标题样式 - 更新现有样式 */

/* 搜索导航样式 */
.search-navigation {
  display: flex;
  align-items: center;
  gap: 8px;

  .match-info {
    font-size: 12px !important;
    color: #666 !important;
    margin-right: 5px !important;
  }

  .el-button {
    padding: 4px 8px;
  }
}


</style>
